import { render, staticRenderFns } from "./laudoClinico.vue?vue&type=template&id=0864016b&scoped=true"
import script from "./laudoClinico.vue?vue&type=script&lang=js"
export * from "./laudoClinico.vue?vue&type=script&lang=js"
import style0 from "./laudoClinico.vue?vue&type=style&index=0&id=0864016b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864016b",
  null
  
)

export default component.exports